import React, { Component } from "react";
import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import { renderErrorMessage } from "../../helper/user_helper";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Loader from "../loader";

let strings = new LocalizedStrings({ en });

class ProfileUpdatePassword extends Component {
  state = { current_password: "", password: "", password_confirmation: "" };
  render() {
    return (
      <div className="profilePage center">
        <div className="edit_logout cursor_btn">
          <div className="right">
            <FontAwesomeIcon
              className="yaystack_icon_navBar yaystack_color mr-3"
              icon={faTimes}
              onClick={this.props.handlerUpdatePassword}
            />
          </div>
        </div>
        <form onSubmit={this.updateUserPassword} className="max_width_300">
          <label className="yaystack_input_text_label mt-4">
            {strings.current_password}
            <input
              className="yaystack_input_text mb-3"
              type="password"
              required={true}
              minLength="8"
              value={this.state.current_password}
              placeholder={strings.current_password}
              onChange={this.handleChangeCurrentPassword}
              autoComplete="current-password"
            />
          </label>
          <br />

          <label className="yaystack_input_text_label">
            {strings.new_password}
            <input
              className="yaystack_input_text mb-3"
              type="password"
              required={true}
              minLength="8"
              value={this.state.password}
              placeholder={strings.new_password}
              onChange={this.handleChangePassword}
              autoComplete="new-password"
            />
          </label>
          <br />

          <label className="yaystack_input_text_label">
            {strings.new_password_confirmation}
            <input
              className="yaystack_input_text mb-3"
              type="password"
              required={true}
              minLength="8"
              value={this.state.password_confirmation}
              placeholder={strings.new_password_confirmation}
              onChange={this.handleChangePasswordConfirmation}
              autoComplete="new-password"
            />
          </label>
          <br />

          {renderErrorMessage(this.props.errors)}
          {renderErrorMessage(this.state.errors)}
          {this.renderSubmitButton()}
        </form>
      </div>
    );
  }

  renderSubmitButton() {
    if (this.props.loaded === false) {
      return <Loader loaded={this.props.loaded} />;
    }
    return (
      <input
        type="submit"
        value={strings.save}
        className="btn btn_primary btn_yaystack mb-2 mt-1 width_100"
      />
    );
  }

  updateUserPassword = event => {
    let errors = "";
    this.setState({ errors });
    event.preventDefault();
    if (this.state.password !== this.state.password_confirmation) {
      let errors = "Password is not similar to password confirmation";
      this.setState({ errors });
      return;
    }
    this.props.updatePassword(
      this.state.password,
      this.state.password_confirmation,
      this.state.current_password
    );
  };

  handleChangeCurrentPassword = event => {
    this.setState({ current_password: event.target.value });
  };

  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleChangePasswordConfirmation = event => {
    this.setState({ password_confirmation: event.target.value });
  };
}

export default ProfileUpdatePassword;



// WEBPACK FOOTER //
// ./src/components/profile/user_profile_update_password.jsx